import { ENABLED } from "../../../../constants/Constants";

import {
    getUserDetailsById,
    handleParticipantConnect,
    handlePlaySoundForParticipantConnectDisconnect,
    initializeRemoteParticipantDeviceInfo,
    updateParticipantCountForDisplay,
} from "../../Room/roomFunction";

import waitingScreenService from "../../../../services/waitingScreenService";
import livePointerService from "../../../LivePointer/livePointerService";
import { LogFirebase } from "../../../../services/firestore";

import { setLivePointerColorsForAllUser } from "../../../LivePointer/LivePointerUtils";
import { dualStreamEnabled, isSilentObserver, showMeVideoEnabled } from "../../../../shared/utility";
import { getRoom } from "../../Room/roomService";
import { setActiveuserlist, setNewActiveUserlist, setTotalUserCount } from "../../../../reducers/common-reducer";
import { cloneDeep } from "lodash";
import { videoOnCallJoinFeature } from "../../../CallScreens/CallTopbar/CallSettings/CallSettingUtils";
import { setParticipantNetworkQuality } from "../../Room/setRemoteParticipantNetworkquality";
import { GLOBAL_MEETING_DATA } from "../../../../constants/PublicVariables";
import { showSilentObserverInParticipantList } from "../../../SilentObserver/SilentObserverUtils";
import CallStatsService from "../../../../services/callStatsService";
import reduxStore from "../../../../configureEnvStore";
import { updateOrAddParticipant } from "../../videoScreenShareOverrideFunction";

export const participantConnectedEvent = (participants, totalParticipants) => {
    const room = getRoom();
    if (participants) {
        console.log("Participant connected:", participants);
        if (GLOBAL_MEETING_DATA.ucid) {
            initializeRemoteParticipantDeviceInfo(participants.identity);
        }
        LogFirebase("TwilioEvents", "remote_participant_connected", { identity: participants.identity });
        waitingScreenService.showProgressBar(false);
        handleParticipantConnect(totalParticipants);
        //// addCallParticipant(participants, "participantConnected");
        setParticipantNetworkQuality(participants);

        const { activeuserlist, newActiveUserList, totalUserCount } = reduxStore.getState().commonReducer;

        if (!activeuserlist.hasOwnProperty(participants.identity)) {
            const copyActiveuserlist = cloneDeep(activeuserlist);
            const copyNewActiveUserList = { ...newActiveUserList };
            const copyTotalUserCount = totalUserCount;

            copyActiveuserlist[participants.identity] = parseInt(copyTotalUserCount) + 1;
            copyNewActiveUserList[participants.identity] = parseInt(copyTotalUserCount) + 1;
            reduxStore.dispatch(setActiveuserlist(copyActiveuserlist));
            reduxStore.dispatch(setNewActiveUserlist(copyNewActiveUserList));
            reduxStore.dispatch(setTotalUserCount(parseInt(copyTotalUserCount) + 1));
        }
        if (dualStreamEnabled()) {
            if (isSilentObserver(participants.identity)) {
                console.log("do nothing");
            } else {
                const participantDetails = {
                    identity: participants.identity,
                    isVideoStreaming: false, // or false
                    isScreenShareStreaming: false,
                    device_type: getUserDetailsById(participants.identity)?.device_type || null,
                };
                console.log("setGalleryViewConnectedUser_participantConnectedEvent", participantDetails);
                // Call the function to update or add the participant
                updateOrAddParticipant(participantDetails, false, true); // false for not remove participant, true for add new participant
            }
        }

        handlePlaySoundForParticipantConnectDisconnect(true, participants.identity);

        if (livePointerService.getLivePointerFeatureFlagValue() == ENABLED) {
            setLivePointerColorsForAllUser(participants.identity);
        }

        updateParticipantCountForDisplay(participants.identity, "increment");

        if (room.participants.size < 2 && showMeVideoEnabled()) {
            console.log("videoOnCallJoinFeature___participantConnectedEvent", room.participants.size);
            videoOnCallJoinFeature();
        }
        /* for silent observer identity show in Agent side */
        setTimeout(() => {
            showSilentObserverInParticipantList(participants.identity);
        }, 3000);
        console.log("ParticipantConnectedEvent");
        // if callStats haven't started and first particpant joined
        if (!reduxStore.getState().callStats.callStatsStarted) {
            console.error("::callstats from parti connected");
            CallStatsService.callStats(false);
        }
    }
};
